var map = {
	"./Rubeus.svg": 4333,
	"./ai-stars.svg": 9595,
	"./ai-studio-logo.svg": 2602,
	"./assistent-logo.svg": 7501,
	"./assistent.svg": 8623,
	"./base-conhecimentos.svg": 498,
	"./color-picker-pencil.svg": 8753,
	"./dados.svg": 5910,
	"./empty-background.svg": 1825,
	"./geracao-conteudo-logo.svg": 9161,
	"./insights-logo.svg": 9170,
	"./logo-base-conhecimentos.svg": 3738,
	"./modelos.svg": 8382,
	"./obrigatorio.svg": 2092,
	"./opcional.svg": 2856,
	"./recomendado.svg": 1802,
	"./robot.svg": 2587,
	"./sair.svg": 8300,
	"./send-icon.svg": 7067,
	"./stars.svg": 3148,
	"./trending-up.svg": 4172,
	"./user.svg": 6296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 419;